import { render } from "./militaryOffice.vue?vue&type=template&id=755f0a98"
import script from "./militaryOffice.vue?vue&type=script&lang=js"
export * from "./militaryOffice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__